import React from "react";

const createProviderHook = context => () => React.useContext(context)

export {
    createProviderHook
}